import { useTranslation } from "react-i18next";

import {
  useSegmentVacancyFilters,
  type UseSegmentVacancyFiltersParams,
} from "../api/useSegmentVacancyFilters";
import { VACANCY_FILTER_KEY, type VacancyFilterKey } from "../constants";

import type { FilterSectionConfig } from "@/components/ui/v2/filters/FiltersDrawer";

export type VacancyFilterSection = Extract<
  FilterSectionConfig,
  { options: unknown }
> & { key: VacancyFilterKey };

const OVERRIDE_FILTER = {
  MANUAL: "Manual",
  RULE_BASED: "RuleBased",
  REDUNDANT: "Redundant",
} as const;

export function useVacancyFilterSections(
  params: UseSegmentVacancyFiltersParams,
) {
  const { t } = useTranslation();
  const { data: options, isLoading } = useSegmentVacancyFilters(params);

  const overrideOption = (value: string, label: string) => ({
    value,
    label,
    count: options?.override.find((option) => option.value === value)?.count,
  });

  const sections: VacancyFilterSection[] = [
    {
      key: VACANCY_FILTER_KEY.OVERRIDE,
      title: t("admin.segments.builder.vacancies.filters.exception"),
      options: [
        overrideOption(
          OVERRIDE_FILTER.MANUAL,
          t("admin.segments.builder.vacancies.filters.manual"),
        ),
        overrideOption(
          OVERRIDE_FILTER.RULE_BASED,
          t("admin.segments.builder.vacancies.filters.ruleBased"),
        ),
        overrideOption(
          OVERRIDE_FILTER.REDUNDANT,
          t("admin.segments.builder.vacancies.filters.redundant"),
        ),
      ],
    },
    {
      key: VACANCY_FILTER_KEY.FIELD,
      title: t("admin.segments.builder.fields.field"),
      options: options?.field ?? [],
    },
    {
      key: VACANCY_FILTER_KEY.CITY,
      title: t("admin.segments.builder.fields.vacancyLocCity"),
      options: options?.city ?? [],
    },
    {
      key: VACANCY_FILTER_KEY.COMPANY,
      title: t("admin.segments.builder.fields.company"),
      options: options?.company ?? [],
    },
  ];

  return { sections, isLoading };
}
